<template>
  <div class="container">
    <div style="display: flex; justify-content: space-between">
      <div style="display: flex">
        <el-input
          v-model="keyword"
          style="width: 250px"
          placeholder="请输入学校名称"
        >
        </el-input>
        <el-select
          v-model="school"
          @change="onSearch"
          placeholder="请选择"
          style="width: 100px; margin-left: 20px"
        >
          <el-option value="0" label="小学组"></el-option>
          <el-option value="1" label="中学组"></el-option>
        </el-select>
        <el-input
          v-model="address"
          style="width: 180px; margin-left: 20px"
          placeholder="请输入学校地址"
        >
        </el-input>
        <el-button type="primary" style="margin-left: 20px" @click="onSearch"
          >查询</el-button
        >
      </div>
      <div>
        <el-button type="primary" @click="download">导出</el-button>
      </div>
    </div>
    <!-- table -->
    <div style="margin-top: 20px">
      <el-table
        :data="tableList"
        v-loading="dataListLoading"
        style="width: 100%"
        height="600"
      >
        <el-table-column
          label="序号"
          width="50"
          type="index"
          header-align="center"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          v-for="(item, key) in columns"
          :key="key"
          :width="item.width || 'auto'"
          align="center"
          :label="item.label"
        >
          <template slot-scope="scope">
            <div v-if="!item.slot">{{ scope.row[item.prop] }}</div>
            <div v-else>
              <div v-if="item.prop === 'applyUrl'">
                <a
                  :href="scope.row[item.prop]"
                  target="_blank"
                  style="color: #409eff"
                  >点击查看</a
                >
              </div>
              <div v-if="item.prop === 'review'">
                <el-button type="text" @click="goReview(scope.row)"
                  >进行评审</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="margin-top: 20px">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page="pageNum"
        @current-change="currentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
      >
      </el-pagination>
    </div>

    <!-- [新增] 选择分组弹窗 -->
    <el-dialog
      :visible.sync="groupDialogVisible"
      width="630px"
      :show-close="true"
      custom-class="group-selection-dialog"
      :close-on-click-modal="false"
      center
    >
      <div slot="title" class="dialog-title">选择要评审的分组</div>
      <div class="group-cards">
        <!-- 小学组卡片 -->
        <div class="group-card elementary" @click="selectGroup('0')">
          <div class="card-content">
            <div class="character-wrapper">
              <div class="placeholder-img primary-img"></div>
            </div>
          </div>
        </div>

        <!-- 中学组卡片 -->
        <div class="group-card middle" @click="selectGroup('1')">
          <div class="card-content">
            <div class="character-wrapper">
              <div class="placeholder-img middle-img"></div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <reviewPage ref="review" />
  </div>
</template>

<script>
import { $activity } from "@/services";
import { BASE } from "@/services/base";
import reviewPage from "./components/reviewPage.vue";
import XLSX from "xlsx";
// [新增] 导入 Vuex 辅助函数
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    reviewPage,
  },
  data() {
    return {
      columns: [
        { prop: "schoolName", label: "学校名称", width: "200" },
        { prop: "province", label: "省份" },
        { prop: "studentName", label: "观测员", width: "300" },
        { prop: "applyUrl", label: "报名表", slot: true },
        { prop: "review", label: "操作", slot: true },
      ],
      dataListLoading: false,
      tableList: [],
      pageNum: 1,
      pageSize: 10,
      keyword: "",
      total: 0,
      action: BASE + "/server/common/upload",
      id: "",
      isreport: false,
      school: "", // 0: 小学, 1: 中学
      day: 20,
      address: "",
      groupDialogVisible: true, // [新增] 控制分组选择弹窗
      isLoggedIn: false,
    };
  },
  // [新增] Vuex 计算属性
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    // 1. 使用 mapGetters 从 'match' 模块获取届数
    ...mapGetters("match", ["currentMatchVersion"]),
  },
  created() {
    const userInfo = this.userInfo;
    if (!userInfo || !userInfo.id) {
      this.$message.error("您尚未登录，请先登录");
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath },
      });
      this.isLoggedIn = false;
      return;
    }
    const userType = Number(userInfo.type);
    if (userType !== 9 && userType !== 91) {
      this.$message.error("您没有权限访问评审页面");
      this.$router.push("/map");
      this.isLoggedIn = false;
      return;
    }
    // [新增] 确保 Vuex store 中的届数列表已加载
    this.$store.dispatch("match/fetchMatchVersionList");

    // 初始化时不需要自动调用 getTableList，等待用户选择分组
  },
  methods: {
    onSearch() {
      this.pageNum = 1;
      this.getTableList();
    },
    // [新增] 选择分组方法
    selectGroup(type) {
      this.school = type;
      this.groupDialogVisible = false;
      this.pageNum = 1;
      this.onSearch();
    },
    async getTableList() {
      // [新增] 确保 currentMatchVersion 存在后再调用
      if (!this.currentMatchVersion) {
        // 如果届数尚未加载, 稍后再试
        setTimeout(this.getTableList, 200);
        return;
      }

      if (!this.dataListLoading) {
        this.dataListLoading = true;
        let params = {};
        params.pageNum = this.pageNum;
        params.pageSize = this.pageSize;
        params.keyword = this.keyword;
        params.school = this.school;
        params.userId = this.userInfo?.id;
        params.days = this.day;
        params.address = this.address;
        params.havingPass = true;
        // [修改] 传入 matchVersion
        params.matchVersion = this.currentMatchVersion;

        let res = await $activity.signList(params);
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableList = res.data.records;
        }
        this.dataListLoading = false;
      }
    },
    currentChange(e) {
      this.pageNum = e;
      this.getTableList();
    },
    prevClick(e) {
      this.pageNum = e;
      this.getTableList();
    },
    nextClick(e) {
      this.pageNum = e;
      this.getTableList();
    },

    goReview(row) {
      // [修改] 传入 matchVersion, 假设 reviewPage.vue 组件需要它
      this.$refs.review.setFlag(row, this.currentMatchVersion);
    },
    // 导出
    async download() {
      let field = [
        "schoolName",
        "province",
        "address",
        "teacher1",
        "teacher1Contact",
        "teacher2",
        "teacher2Contact",
        "studentName",
        "total",
        "maxCount",
        "isreportUrl",
      ];
      let label = {
        schoolName: "学校名称",
        province: "省份",
        address: "详细地址",
        maxTemTime: "出现时间",
        teacher1: "指导老师1",
        minTemTime: "出现时间",
        teacher1Contact: "指导老师1电话",
        teacher2: "指导老师2",
        teacher2Contact: "指导老师2电话",
        studentName: "参赛学生",
        total: "观测总天数",
        maxCount: "最高连续观测天数",
        isreportUrl: "是否上传论文",
      };

      // [新增] 确保 currentMatchVersion 存在
      if (!this.currentMatchVersion) {
        this.$message.warning("正在加载届数信息, 请稍后再试");
        return;
      }

      let params = {};
      params.pageNum = 1;
      params.pageSize = 99999;
      params.userId = this.userInfo?.id;
      params.keyword = "";
      params.days = 20;
      params.school = this.school;
      params.havingPass = true;
      params.address = "";
      // [修改] 传入 matchVersion
      params.matchVersion = this.currentMatchVersion;

      let reportData = await $activity.signList(params);

      if (!reportData.data.records || reportData.data.records.length === 0) {
        this.$message.warning("没有可导出的数据");
        return;
      }

      reportData.data.records.forEach((item) => {
        if (item.reportUrl) {
          item.isreportUrl = "是";
        } else {
          item.isreportUrl = "否";
        }
      });
      let lastCol = XLSX.utils.encode_col(field.length - 1);
      let lastRow = XLSX.utils.encode_row(reportData.data.records.length);
      const ws = XLSX.utils.json_to_sheet(reportData.data.records, {
        header: field,
      });
      const range = XLSX.utils.decode_range(ws["!ref"]);
      ws["!ref"] = `A1:${lastCol}${lastRow}`;
      for (let c = range.s.c; c <= range.e.c; c++) {
        const header = XLSX.utils.encode_col(c) + "1";
        ws[header].v = label[ws[header].v];
      }
      const wb = XLSX.utils.book_new();
      let sheetName = this.device_type || "Sheet1";
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, `报名学校表.xlsx`);
    },
  },
  // [新增] 监听 Vuex state 的变化
  watch: {
    // 监听 'currentMatchVersion' (来自 computed) 的变化
    currentMatchVersion(newValue, oldValue) {
      if (newValue && newValue !== oldValue && !this.groupDialogVisible) {
        this.onSearch();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 40px;
}

/deep/ .el-input__inner,
/deep/ .el-button,
/deep/ .el-select-dropdown__item,
/deep/ .el-descriptions-row,
/deep/ .el-pagination__total,
/deep/ .el-pagination button,
/deep/ .el-pager li {
  font-size: 18px !important;
}

/deep/ .el-table {
  font-size: 18px;
  .el-table__header-wrapper th {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}

/* [新增] 弹窗相关样式 */
/deep/ .group-selection-dialog {
  background: url("~@/assets/sign/bg.png") center no-repeat;
  border-radius: 20px;
  overflow: hidden;
  width: 630px;
  height: 470px;
  box-shadow: none;

  .el-dialog__header {
    padding: 20px;
    background: transparent;
    .dialog-title {
      margin-top: 20px;
      font-size: 36px;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #808080;
      font-size: 30px;
      background: #fff;
      border-radius: 50%;
      margin-top: -40px;
    }
  }

  .el-dialog__body {
    padding: 30px 40px 60px;
  }
}

.group-cards {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
}

.group-card {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;

  &:hover {
    transform: translateY(-10px);
  }

  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .character-wrapper {
    width: 231px;
    height: 326px;
    border-radius: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    .placeholder-img {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    /* 建议在这里放入您设计稿对应的插画资源地址 */
    .primary-img {
      background-image: url("~@/assets/sign/elementary.png");
      opacity: 0.8;
    }
    .middle-img {
      background-image: url("~@/assets/sign/middle.png");
      opacity: 0.8;
    }
  }

  .label-badge {
    padding: 10px 40px;
    border-radius: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .primary-badge {
    background: linear-gradient(90deg, #409eff 0%, #66b1ff 100%);
  }

  .middle-badge {
    background: linear-gradient(90deg, #e6a23c 0%, #ebbb7a 100%);
  }
}
</style>